import React from "react";
import { IconButton, TableCell, TextField } from "@material-ui/core";
import AddIcon from "@mui/icons-material/Add";
import AtColorPalette from "../../../../components/AtColorPalette/AtColorPalette";
import { toast } from "react-toastify";
import { withTranslation } from 'react-i18next';

function ThresholdForm({ addItem, colors, disabled, t }) {
    const [limite, setLimite] = React.useState(1);
    const [color, setColor] = React.useState("#ffffff");

    function handleUpdateColor(value) {
        setColor(value);
    }

    function addNewLimite() {
        if (color === "#ffffff") {
            toast.error(t('thresholdConfig.form.selectColor'));
            return;
        }
        addItem(Number(limite), color);
        setLimite(1);
        setColor("#ffffff");
    }

    function handleUpdateLimite(event) {
        const { value } = event.target;
        if (!isNaN(Number(value))) {
            setLimite(value);
        }
    }

    function preventPaste(e) {
        e.preventDefault();
        return false;
    }

    return (
        <>
            <TableCell>{t('thresholdConfig.table.header.limit')}</TableCell>
            <TableCell>
                <TextField
                    variant="outlined"
                    size="small"
                    value={limite}
                    onChange={handleUpdateLimite}
                    type="number"
                    min="0"
                    max="100"
                    onKeyDown={(e) =>["e", "E", "+", "-", ".", "´", "¨"].includes(e.key) && e.preventDefault()}
                    onPaste={preventPaste}
                    inputProps={{ min: 0, max: 100}}
                />
            </TableCell>
            <TableCell>{t('thresholdConfig.table.header.color')}</TableCell>
            <TableCell>
                <AtColorPalette
                    value={color}
                    onChange={handleUpdateColor}
                    colors={colors}
                    style={{
                        width: 25,
                        height: 25,
                        borderRadius: 5,
                    }}
                    disabled={disabled}
                />
            </TableCell>
            <TableCell>
                <IconButton onClick={addNewLimite} disabled={disabled}>
                    <AddIcon color="success" />
                </IconButton>
            </TableCell>
        </>
    );
}

export default withTranslation()(ThresholdForm);
